var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-space-between": "" } },
            [
              _c(
                "span",
                _vm._l(_vm.tabs, function(tabItem) {
                  return _c("v-tab", { key: tabItem }, [
                    _vm._v("\n          " + _vm._s(tabItem) + "\n        ")
                  ])
                }),
                1
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("balance")) +
                    ": $ " +
                    _vm._s(_vm.systemBalance.balance) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showCreateLabelDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("domesticLabel")))
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showCreateLabelInternationalDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("exportFromUS")))
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showCreateLabelImportDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("importToUS")))
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                dark: _vm.visibleBetaFeatures.includes(
                                  "FEDEX_LTL"
                                ),
                                color: "primary",
                                disabled: !_vm.visibleBetaFeatures.includes(
                                  "FEDEX_LTL"
                                )
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showCreateFreightLabelDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("freightLabel")) +
                                  "\n            "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.checkPathAnnouncement(_vm.$route.path)
                        ? _c(
                            "v-flex",
                            { attrs: { xs3: "", md2: "" } },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showPathAnnouncement(
                                                        _vm.$route.path
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "blue" } },
                                                  [_vm._v("info")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    478533147
                                  )
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("importantInformation")) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("PaginationController", {
                    attrs: {
                      getDataActionName: "getLabelPagination",
                      historyLimit: _vm.historyLimit,
                      select: _vm.selectText,
                      haveStartDate: "",
                      startDate: _vm.startDate,
                      showSearchBoxLabel: false,
                      actionPredicates: _vm.generatePredicate(),
                      isPagination: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "dataTable",
                        fn: function() {
                          return [
                            _c("v-data-table", {
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.labels,
                                "hide-actions": "",
                                "item-key": "_key",
                                "select-all": "blue"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "checkbox-align-center",
                                          on: {
                                            click: function($event) {
                                              props.item.url &&
                                                props.item.status !==
                                                  "canceled" &&
                                                (props.selected = !props.selected)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  disabled:
                                                    !props.item.url ||
                                                    props.item.status ===
                                                      "canceled",
                                                  value: props.selected,
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      props.selected = !props.selected
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelDetailsWidget", {
                                            attrs: {
                                              shipmentLabel: props.item,
                                              index: props.index
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: { address: props.item.from }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: { address: props.item.to }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.$store.getters.activeWarehouse
                                        ? _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.organizationKeyToId.get(
                                                      props.item.clientKey
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.toDateYYYYMMDD(
                                                    props.item.createTime
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.shipDate) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          props.item.estimatedDelivery &&
                                          props.item.estimatedDelivery !== "N/A"
                                            ? _c(
                                                "v-layout",
                                                {
                                                  staticClass: "text-capitalize"
                                                },
                                                [
                                                  typeof props.item
                                                    .estimatedDelivery ===
                                                  "string"
                                                    ? _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              new Date(
                                                                props.item.estimatedDelivery
                                                              )
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("v-flex", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.toDateYYYYMMDD(
                                                              props.item
                                                                .estimatedDelivery
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          props.item.status !== "failed"
                                            ? [
                                                _c(
                                                  "LabelTrackingDetailWidget",
                                                  {
                                                    attrs: {
                                                      trackingNumber:
                                                        props.item
                                                          .trackingNumber,
                                                      status: props.item.status,
                                                      carrier:
                                                        props.item.carrier,
                                                      details:
                                                        props.item
                                                          .trackingDetails
                                                    }
                                                  }
                                                ),
                                                _vm._v(" "),
                                                [
                                                  "ready",
                                                  "in transit",
                                                  "delivered"
                                                ].includes(props.item.status) &&
                                                !!props.item.trackStatus
                                                  ? _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.trackStatus.toLowerCase()
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            : _c(
                                                "div",
                                                _vm._l(
                                                  props.item.messages,
                                                  function(messageItem) {
                                                    return _c(
                                                      "p",
                                                      { key: messageItem.time },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              messageItem.message
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          props.item.carrier
                                            ? _c("v-layout", [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(props.item.carrier)
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  props.item.serviceDescription
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: props.item.totalAmount
                                            ? "text-xs-left fontRed"
                                            : props.item.amount > 0
                                            ? "text-xs-left fontGreen"
                                            : "text-xs-left fontRed"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  $" +
                                              _vm._s(
                                                -props.item.totalAmount ||
                                                  props.item.amount ||
                                                  0
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                backgroundColor: _vm.isLabelOverOneWeek(
                                                  props.item
                                                )
                                                  ? "yellow"
                                                  : ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.status || "ready"
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-center" },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                row: "",
                                                "justify-center": ""
                                              }
                                            },
                                            [
                                              props.item.status === "pending" &&
                                              _vm.env !== "production"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "LoaderButton",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              promiseAwait:
                                                                                _vm.getLabelStatus,
                                                                              promiseItem:
                                                                                props.item,
                                                                              buttonIcon:
                                                                                "refresh"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "getStatus"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              icon:
                                                                                "",
                                                                              color: props
                                                                                .item
                                                                                .isDownloaded
                                                                                ? "success"
                                                                                : "primary",
                                                                              disabled:
                                                                                !props
                                                                                  .item
                                                                                  .url ||
                                                                                [
                                                                                  "canceled",
                                                                                  "failed"
                                                                                ].includes(
                                                                                  props
                                                                                    .item
                                                                                    .status
                                                                                )
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.downloadFile(
                                                                                  props
                                                                                    .item
                                                                                    .url,
                                                                                  props
                                                                                    .item
                                                                                    .orderKey,
                                                                                  props
                                                                                    .item
                                                                                    ._key
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "preview"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "openLabel"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                              _vm._v(" "),
                                              props.item.invoiceUrl
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              flat:
                                                                                "",
                                                                              icon:
                                                                                "",
                                                                              color:
                                                                                "orange",
                                                                              disabled: [
                                                                                "canceled",
                                                                                "failed"
                                                                              ].includes(
                                                                                props
                                                                                  .item
                                                                                  .status
                                                                              )
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.downloadFile(
                                                                                  props
                                                                                    .item
                                                                                    .invoiceUrl,
                                                                                  props
                                                                                    .item
                                                                                    .orderKey,
                                                                                  props
                                                                                    .item
                                                                                    ._key
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "receipt"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "downloadInvoice"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      attrs: { "offset-y": "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      top: ""
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "activator",
                                                                          fn: function(
                                                                            tooltip
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                _vm._g(
                                                                                  {},
                                                                                  tooltip.on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    {
                                                                                      attrs: {
                                                                                        dark:
                                                                                          "",
                                                                                        icon:
                                                                                          "",
                                                                                        flat:
                                                                                          "",
                                                                                        color:
                                                                                          "primary"
                                                                                      },
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          $event.stopPropagation()
                                                                                          return on.click.apply(
                                                                                            null,
                                                                                            arguments
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "build"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "more"
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list",
                                                        [
                                                          _c(
                                                            "v-list-tile",
                                                            {
                                                              staticClass:
                                                                "list-tile-center"
                                                            },
                                                            [
                                                              _c(
                                                                "LoaderButton",
                                                                {
                                                                  attrs: {
                                                                    flat: "",
                                                                    buttonText: _vm.$t(
                                                                      "editNote"
                                                                    ),
                                                                    promiseAwait:
                                                                      _vm.showEditLabelDialog,
                                                                    promiseItem:
                                                                      props.item
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          props.item
                                                            .requestId ===
                                                          props.item._key
                                                            ? _c(
                                                                "v-list-tile",
                                                                {
                                                                  staticClass:
                                                                    "list-tile-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "LoaderButton",
                                                                    {
                                                                      attrs: {
                                                                        flat:
                                                                          "",
                                                                        buttonText: _vm.$t(
                                                                          "reShip"
                                                                        ),
                                                                        promiseAwait:
                                                                          _vm.copyLabel,
                                                                        promiseItem:
                                                                          props.item
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          props.item.carrier !==
                                                            "USPS" &&
                                                          (props.item.status ===
                                                            "ready" ||
                                                            props.item
                                                              .status ===
                                                              "pending") &&
                                                          props.item
                                                            .requestId ===
                                                            props.item._key
                                                            ? _c(
                                                                "v-list-tile",
                                                                {
                                                                  staticClass:
                                                                    "list-tile-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              tooltip
                                                                            ) {
                                                                              return [
                                                                                _c(
                                                                                  "div",
                                                                                  _vm._g(
                                                                                    {},
                                                                                    tooltip.on
                                                                                  ),
                                                                                  [
                                                                                    _c(
                                                                                      "LoaderButton",
                                                                                      {
                                                                                        attrs: {
                                                                                          flat:
                                                                                            "",
                                                                                          buttonText: _vm.$t(
                                                                                            "cancel"
                                                                                          ),
                                                                                          promiseAwait:
                                                                                            _vm.cancelLabel,
                                                                                          disabled:
                                                                                            _vm.visibleBetaFeatures.includes(
                                                                                              "cancelLabelByDownloaded"
                                                                                            ) &&
                                                                                            props
                                                                                              .item
                                                                                              .isDownloaded,
                                                                                          promiseItem:
                                                                                            props.item
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            props
                                                                              .item
                                                                              .isDownloaded
                                                                              ? _vm.$t(
                                                                                  "contactToCancelLabel"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "cancel"
                                                                                )
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          props.item.carrier &&
                                                          props.item.carrier.toUpperCase() ===
                                                            "FEDEX" &&
                                                          props.item
                                                            .isProofDelivery
                                                            ? _c(
                                                                "v-list-tile",
                                                                {
                                                                  staticClass:
                                                                    "list-tile-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "LoaderButton",
                                                                    {
                                                                      attrs: {
                                                                        flat:
                                                                          "",
                                                                        buttonText: _vm.$t(
                                                                          "updateProofDelivery"
                                                                        ),
                                                                        promiseAwait:
                                                                          _vm.updateProofDelivery,
                                                                        promiseItem:
                                                                          props.item
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.selectedFilteredLabels,
                                callback: function($$v) {
                                  _vm.selectedFilteredLabels = $$v
                                },
                                expression: "selectedFilteredLabels"
                              }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "afterDate",
                        fn: function() {
                          return [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-center": "",
                                      "justify-end": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs5: "" } },
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            label: _vm.isMergePDF
                                              ? "PDF"
                                              : "ZIP"
                                          },
                                          model: {
                                            value: _vm.isMergePDF,
                                            callback: function($$v) {
                                              _vm.isMergePDF = $$v
                                            },
                                            expression: "isMergePDF"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "offset-y": "",
                                              "close-on-content-click": false
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var props = ref.props
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          "v-btn",
                                                          props,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t("export")
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    staticClass:
                                                      "list-tile-center"
                                                  },
                                                  [
                                                    _c("LoaderButton", {
                                                      attrs: {
                                                        flat: "",
                                                        buttonText: _vm.$t(
                                                          "downloadLabelsNum",
                                                          {
                                                            selectedLabelsLength:
                                                              _vm.selectedLabels
                                                                .length
                                                          }
                                                        ),
                                                        promiseAwait:
                                                          _vm.downloadSelectedLabelAndZip,
                                                        disabled:
                                                          _vm.selectedLabels
                                                            .length === 0
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    staticClass:
                                                      "list-tile-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          flat: "",
                                                          color: "primary",
                                                          loading:
                                                            _vm
                                                              .exportLabelsPopup
                                                              .loading
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.showExportLabelsPopup
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "exportLabels"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    staticClass:
                                                      "list-tile-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          flat: "",
                                                          color: "primary",
                                                          disabled:
                                                            _vm.selectedLabels
                                                              .length === 0
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.exportLabelsToExcel(
                                                              {
                                                                labels:
                                                                  _vm.selectedLabels
                                                              }
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "exportSelectedLabels"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.selectedLabels
                                                                .length
                                                            ) +
                                                            ")\n                          "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "beforeMenu",
                        fn: function() {
                          return [
                            _c(
                              "v-layout",
                              { attrs: { "justify-start": "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs3: "", "mr-1": "" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: [
                                          {
                                            name: _vm.$t("keyword"),
                                            value: "keyword"
                                          },
                                          {
                                            name: _vm.$t("batchByRequestId"),
                                            value: "requestIds"
                                          },
                                          {
                                            name: _vm.$t("batchByTracking"),
                                            value: "trackings"
                                          }
                                        ],
                                        "item-value": "value",
                                        "item-text": "name",
                                        label: _vm.$t("searchMode")
                                      },
                                      on: {
                                        change: function(e) {
                                          _vm.searchText = ""
                                          _vm.requestIds = []
                                          _vm.selectText = ""
                                          _vm.searchTrackings = []
                                          _vm.trackStatusValue = ""
                                        }
                                      },
                                      model: {
                                        value: _vm.searchMode,
                                        callback: function($$v) {
                                          _vm.searchMode = $$v
                                        },
                                        expression: "searchMode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.searchMode === "requestIds"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs8: "", "pl-3": "" } },
                                      [
                                        _c("v-combobox", {
                                          attrs: {
                                            label:
                                              _vm.$t("requestId") + "(max: 10)",
                                            "small-chips": "",
                                            "deletable-chips": "",
                                            "return-object": false,
                                            hint:
                                              _vm.$t("requestId") +
                                              " **" +
                                              _vm.$t("enterToNext"),
                                            multiple: "",
                                            clearable: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeBatchSearch(
                                                _vm.requestIds,
                                                "requestIds"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.requestIds,
                                            callback: function($$v) {
                                              _vm.requestIds = $$v
                                            },
                                            expression: "requestIds"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchMode === "trackings"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs8: "", "pl-3": "" } },
                                      [
                                        _c("v-combobox", {
                                          attrs: {
                                            label:
                                              _vm.$t("tracking") + "(max: 10)",
                                            "small-chips": "",
                                            "deletable-chips": "",
                                            "return-object": false,
                                            hint:
                                              _vm.$t("trackingNumber") +
                                              " **" +
                                              _vm.$t("enterToNext"),
                                            multiple: "",
                                            clearable: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeBatchSearch(
                                                _vm.searchTrackings,
                                                "searchTrackings"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.searchTrackings,
                                            callback: function($$v) {
                                              _vm.searchTrackings = $$v
                                            },
                                            expression: "searchTrackings"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchMode === "keyword"
                                  ? [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.labelStatusArray,
                                              "item-value": "value",
                                              "item-text": "name",
                                              label: _vm.$t("labelStatus")
                                            },
                                            model: {
                                              value: _vm.selectText,
                                              callback: function($$v) {
                                                _vm.selectText = $$v
                                              },
                                              expression: "selectText"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-1": "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.trackStatusArray,
                                              "item-value": "value",
                                              "item-text": "name",
                                              label: _vm.$t("trackStatus")
                                            },
                                            model: {
                                              value: _vm.trackStatusValue,
                                              callback: function($$v) {
                                                _vm.trackStatusValue = $$v
                                              },
                                              expression: "trackStatusValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "", "ml-3": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              hint:
                                                _vm.$t("memo") +
                                                "/" +
                                                _vm.$t("recipient") +
                                                "/" +
                                                _vm.$t("serviceType") +
                                                "/" +
                                                _vm.$t("tracking"),
                                              label: _vm.$t("search"),
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.searchText,
                                              callback: function($$v) {
                                                _vm.searchText = $$v
                                              },
                                              expression: "searchText"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.labels,
                      callback: function($$v) {
                        _vm.labels = $$v
                      },
                      expression: "labels"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isModeLabel
                ? _c(
                    "v-tab-item",
                    [_c("ApiLabel", { staticStyle: { padding: "0" } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showCreateAddressDialog.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("address")))
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.enableAmazonSites
                        ? _c(
                            "v-flex",
                            { attrs: { xs1: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.isOnlyShowCustomSites
                                    ? _vm.$t("custom")
                                    : _vm.$t("all")
                                },
                                model: {
                                  value: _vm.isOnlyShowCustomSites,
                                  callback: function($$v) {
                                    _vm.isOnlyShowCustomSites = $$v
                                  },
                                  expression: "isOnlyShowCustomSites"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        _vm._l(_vm.addressesDisplay, function(address) {
                          return _c(
                            "v-flex",
                            { key: address.siteName, attrs: { md2: "" } },
                            [
                              _c("LabelAddressCard", {
                                attrs: { address: address },
                                on: {
                                  delete: function($event) {
                                    return _vm.deleteAddress(address)
                                  },
                                  edit: function($event) {
                                    return _vm.showEditAddressDialog(address)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-layout",
                    { attrs: { "justify-space-between": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showAddPackagingDialog.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("packaging")))
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md2: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "text-xs-right",
                            attrs: {
                              "append-icon": "filter_list",
                              label: _vm.$t("search"),
                              "single-line": "",
                              "hide-details": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.filter,
                              callback: function($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "my-1 levation-2 myDense",
                    attrs: {
                      headers: _vm.packagingHeaders,
                      items: _vm.packagings,
                      "rows-per-page-items": _vm.rowPerPage,
                      search: _vm.filter
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c("td", { staticClass: "subheading" }, [
                              _vm._v(_vm._s(props.index + 1))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.name))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                _vm._s(props.item.length) +
                                  " " +
                                  _vm._s(
                                    props.item.isMeasurementMetric ? "cm" : '"'
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                _vm._s(props.item.width) +
                                  " " +
                                  _vm._s(
                                    props.item.isMeasurementMetric ? "cm" : '"'
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                _vm._s(props.item.height) +
                                  " " +
                                  _vm._s(
                                    props.item.isMeasurementMetric ? "cm" : '"'
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getPackagingWeightForDisplay(props.item)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-right" },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showEditPackagingDialog(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("edit")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deletePackaging(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delete")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ShippingTemplateTab", { staticStyle: { padding: "0" } }),
              _vm._v(" "),
              _c("LabelTemplateTab", { staticStyle: { padding: "0" } }),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [_c("ProofDeliveryHistory", { staticStyle: { padding: "0" } })],
                1
              ),
              _vm._v(" "),
              _c("CommodityTemplateTab")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.createLabelDialog
        ? _c("LabelCreatePopup", {
            attrs: {
              froms: _vm.addresses,
              idGenerator: _vm.labelIdGenerator,
              labelInfo: _vm.labelInfo,
              dangerousGoodsInfo: _vm.dangerousGoodsInfo,
              isFreight: _vm.isFreight,
              businessType: "domestic"
            },
            on: {
              "update:dangerousGoodsInfo": function($event) {
                _vm.dangerousGoodsInfo = $event
              },
              "update:dangerous-goods-info": function($event) {
                _vm.dangerousGoodsInfo = $event
              },
              submitted: _vm.updateLabelStatus
            },
            model: {
              value: _vm.createLabelDialog,
              callback: function($$v) {
                _vm.createLabelDialog = $$v
              },
              expression: "createLabelDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createAddressDialog
        ? _c("LabelCreateAddress", {
            attrs: {
              actionFunc: _vm.addressFunc,
              address: _vm.addressInEdit,
              siteNames: _vm.siteNames
            },
            model: {
              value: _vm.createAddressDialog,
              callback: function($$v) {
                _vm.createAddressDialog = $$v
              },
              expression: "createAddressDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.packagingDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("packaging"),
              medium: "",
              rightMethod: _vm.editPackaging,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.packagingDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("name"),
                                      rules: [_vm.fieldIsRequired()],
                                      disabled: _vm.isEdit
                                    },
                                    model: {
                                      value: _vm.packagingInEdit.name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.packagingInEdit,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "packagingInEdit.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("length"),
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsValidPkgInfo(),
                                        _vm.fieldIsOverZero()
                                      ],
                                      suffix: _vm.$t(
                                        _vm.isMeasurementMetric ? "cm" : "inch"
                                      )
                                    },
                                    model: {
                                      value: _vm.packagingInEdit.length,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.packagingInEdit,
                                          "length",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "packagingInEdit.length"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("width"),
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsValidPkgInfo(),
                                        _vm.fieldIsOverZero()
                                      ],
                                      suffix: _vm.$t(
                                        _vm.isMeasurementMetric ? "cm" : "inch"
                                      )
                                    },
                                    model: {
                                      value: _vm.packagingInEdit.width,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.packagingInEdit,
                                          "width",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "packagingInEdit.width"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("height"),
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsValidPkgInfo(),
                                        _vm.fieldIsOverZero()
                                      ],
                                      suffix: _vm.$t(
                                        _vm.isMeasurementMetric ? "cm" : "inch"
                                      )
                                    },
                                    model: {
                                      value: _vm.packagingInEdit.height,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.packagingInEdit,
                                          "height",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "packagingInEdit.height"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("weight"),
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsValidPkgInfo(),
                                        _vm.fieldIsOverZero()
                                      ],
                                      suffix: _vm.$t(
                                        _vm.isMeasurementMetric ? "kg" : "lb"
                                      )
                                    },
                                    model: {
                                      value: _vm.packagingInEdit.weight,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.packagingInEdit,
                                          "weight",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "packagingInEdit.weight"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              613168512
            ),
            model: {
              value: _vm.packagingDialog,
              callback: function($$v) {
                _vm.packagingDialog = $$v
              },
              expression: "packagingDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editLabelDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("editNote"),
              medium: "",
              rightMethod: _vm.editLabel,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.editLabelDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("note"),
                                      rules: [_vm.fieldCharLimit("Note", 100)],
                                      counter: "100"
                                    },
                                    model: {
                                      value: _vm.labelInEdit.note,
                                      callback: function($$v) {
                                        _vm.$set(_vm.labelInEdit, "note", $$v)
                                      },
                                      expression: "labelInEdit.note"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2140604301
            ),
            model: {
              value: _vm.editLabelDialog,
              callback: function($$v) {
                _vm.editLabelDialog = $$v
              },
              expression: "editLabelDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createLabelInternationalDialog
        ? _c("LabelCreateInternationalPopup", {
            attrs: {
              froms: _vm.addresses,
              idGenerator: _vm.labelIdGenerator,
              labelInfo: _vm.labelInfo,
              businessType: "export"
            },
            on: { submitted: _vm.updateLabelStatus },
            model: {
              value: _vm.createLabelInternationalDialog,
              callback: function($$v) {
                _vm.createLabelInternationalDialog = $$v
              },
              expression: "createLabelInternationalDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createLabelImportDialog
        ? _c("LabelCreateImportToUsPopup", {
            attrs: {
              froms: _vm.addresses,
              idGenerator: _vm.labelIdGenerator,
              labelInfo: _vm.labelInfo,
              businessType: "import"
            },
            on: { submitted: _vm.updateLabelStatus },
            model: {
              value: _vm.createLabelImportDialog,
              callback: function($$v) {
                _vm.createLabelImportDialog = $$v
              },
              expression: "createLabelImportDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("exportLabels"),
          rightMethod: _vm.exportLabels,
          rightButtonText: _vm.$t("export"),
          small: "",
          hasAlert: ""
        },
        on: {
          popupClose: function($event) {
            _vm.exportLabelsPopup.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("DatePicker", {
                          attrs: {
                            label: _vm.$t("date"),
                            range: "",
                            max: _vm.dateMax,
                            min: _vm.dateMin
                          },
                          model: {
                            value: _vm.exportLabelsPopup.dates,
                            callback: function($$v) {
                              _vm.$set(_vm.exportLabelsPopup, "dates", $$v)
                            },
                            expression: "exportLabelsPopup.dates"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.exportLabelsPopup.show,
          callback: function($$v) {
            _vm.$set(_vm.exportLabelsPopup, "show", $$v)
          },
          expression: "exportLabelsPopup.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ae65e18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae65e18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Label.vue
// module id = null
// module chunks = 